export const ComponentIds = {
  LIST_COMPONENT: 'TagList',
};

export const TagRoute = {
  TAGS: 'tags',
};

export const TagPathName = {
  TAGS: 'tags',
  TAGFORM_NEW: 'tagform:new',
  TAGFORM: 'tagform',
};
